import React, { useEffect } from 'react'
import { useState } from 'react';
import CommentInput from '../../forms/commentInput';
import CommentList from './commentList';
import ApiUrl from '../../../configTools/apiUrl';


const Index = ({productID,comments,setComments}) => {
    const [User,setUser] = useState(JSON.parse(localStorage.getItem("user-info")));
    const [Comment, setComment] = useState("");
    const [Replyto, setReplyto] = useState({
        id: 0,
        username: ""
    });
    const RefreshComment = ()=>{
      fetch(ApiUrl.API_URL_Comments+"/"+productID)
      .then(res=>res.json())
      .then(data =>{
        setComments(data);
      });
    }
    const post_comment = ()=>{
        if(Comment === null || Comment === ""){
          return;
        }
        fetch(ApiUrl.API_URL_Comments, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+User.token
          },
          body: JSON.stringify({
            productid : parseInt(productID),
            discription: Comment,
            replyto: Replyto.id
          })
        })
        .then(res=>res.json())
        .then(data =>{
          setComment('');
          RefreshComment();
        });
    }
    useEffect(()=>{
        fetch(ApiUrl.API_URL_Comments+"/"+productID)
        .then(res=>res.json())
        .then(data =>{
          setComments(data);
        });
    },[])

  return (
    <div className='commentBox_Container'>
        <div className='comment_list_wrapper'>
            <CommentList comments={comments} RefreshComment={RefreshComment} setReplyto={setReplyto}/>
        </div>
        <div className='comment_post_container'>
            {Replyto.id !== 0 &&
                <div className='comment_post_reply'>
                    <p>Replying to: {Replyto.username}</p>
                    <button onClick={()=>{
                        setReplyto({
                            id: 0,
                            username: ""
                        });
                    }}>X</button>
                </div>
            }
            {User === null &&
              <CommentInput Value={Comment} setValue={setComment} Action={()=>{}} />
            }
            {User !== null &&
              <CommentInput Value={Comment} setValue={setComment} Action={post_comment} />
            }
        </div>
    </div>
  )
}

export default Index
